module.exports = __webpack_public_path__ + "static/media/stagecoach-logo.176d591a.png";